import { MODULES_CONFIG } from 'basics/constants/common.constants';
import { ConfigModule } from 'basics/enums/general.enums';

export const useGetConfig = () => {
  const currentModule = MODULES_CONFIG[ConfigModule.Default as keyof typeof MODULES_CONFIG];

  return currentModule;
};
